Number.prototype.toCurrency = function () {
    return this.toString().toCurrency();
};